var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M15 20.65v-3.983a.667.667 0 00-.667-.667h-2.667a.667.667 0 00-.666.667v3.988a.667.667 0 01-.664.667l-4.67.012a.666.666 0 01-.665-.667v-6.83l7.683-6.328a.507.507 0 01.637 0l7.68 6.325v6.833a.667.667 0 01-.667.667l-4.667-.013a.667.667 0 01-.666-.667v-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#417DC8",
    d: "M24.888 12.515l-1.063 1.292a.5.5 0 01-.703.069L13.32 5.801a.507.507 0 00-.637 0l-9.802 8.074a.5.5 0 01-.704-.068l-1.062-1.292a.5.5 0 01.068-.704l10.545-8.686a2.002 2.002 0 012.542 0L18 6.192V3.167a.5.5 0 01.5-.5h2.333a.5.5 0 01.5.5v5.771l3.483 2.872a.5.5 0 01.074.703l-.002.002z"
  }))));
}

export default SvgHomeActive;